"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBackStep = useBackStep;
function useBackStep([prevState, dispatch]) {
  return [{
    ...prevState,
    isBackEnabled: prevState.currentStep !== 0
  }, dispatch];
}
